import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M20.739 8.12998L15.87 3.26098C15.699 3.08998 15.474 3 15.231 3H4.8C3.81 3 3 3.81 3 4.8V19.2C3 20.19 3.81 21 4.8 21H19.2C20.19 21 21 20.19 21 19.2V8.769C21 8.526 20.901 8.29198 20.739 8.12998ZM19.2 18.291C19.2 18.786 18.795 19.191 18.3 19.191H5.7C5.205 19.191 4.8 18.786 4.8 18.291V5.69099C4.8 5.19599 5.205 4.79099 5.7 4.79099H13.8V8.39099C13.8 9.38099 14.61 10.191 15.6 10.191H19.2V18.291Z' />
        </SvgIcon>
    );
});
